module.exports = __webpack_public_path__ + "static/media/6.806b2260.png";